import { render } from "./_newProduct.vue?vue&type=template&id=7972a296&scoped=true"
import script from "./_newProduct.vue?vue&type=script&lang=js"
export * from "./_newProduct.vue?vue&type=script&lang=js"

import "./_newProduct.vue?vue&type=style&index=0&id=7972a296&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7972a296"]])

export default __exports__